'use client';

import React from 'react';
import { FaTimes } from 'react-icons/fa';
import Button from '@/components/ui/Button';
import Input from '@/components/ui/Input';

interface CashOutModalProps {
  isOpen: boolean;
  onClose: () => void;
  formData: {
    amount: string;
    password: string;
  };
  onInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSubmit: () => void;
  isLoading?: boolean;
}

const CashOutModal: React.FC<CashOutModalProps> = ({
  isOpen,
  onClose,
  formData,
  onInputChange,
  onSubmit,
  isLoading = false
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Cash Out</h3>
          <button onClick={onClose} className="modal-close">
            <FaTimes />
          </button>
        </div>
        <div className="modal-body">
          <div className="form-group">
            <Input
              label="Amount"
              name="amount"
              type="number"
              value={formData.amount}
              onChange={onInputChange}
              placeholder="Enter amount to withdraw"
            />
          </div>
          <div className="form-group">
            <Input
              label="Password"
              name="password"
              type="password"
              value={formData.password}
              onChange={onInputChange}
              placeholder="Enter your password"
              showPasswordToggle={true}
            />
          </div>
        </div>
        <div className="modal-footer">
          <Button
            variant="casino"
            onClick={onSubmit}
            isLoading={isLoading}
            disabled={!formData.amount || !formData.password}
          >
            Submit
          </Button>
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CashOutModal;
